export const useIsInLivePreview = () => {
  const route = useRoute()
  return !!route.query['live-preview']
}
